import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 58,
    seconds: 50
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 right-0 z-50 bg-slate-50 border-b border-slate-200/60 py-1.5 px-4 text-center" data-id="element-280">
      <div className="block md:hidden" data-id="element-281">
        <p className="text-[13px] font-bold text-slate-800 leading-tight" data-id="element-282">
          Hoy: Sistema Mamá IA por $6.36
        </p>
        <p className="text-[11px] font-medium text-slate-400 leading-tight mt-0.5" data-id="element-283">
          Vuelve a $47.00 en{' '}
          <span className="font-mono tabular-nums text-slate-500" data-id="element-284">
            {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
            {formatTime(timeLeft.seconds)}
          </span>
        </p>
      </div>
      <p className="hidden md:block text-sm font-medium text-slate-600 tracking-wide" data-id="element-285">
        Hoy: Sistema Mamá IA por{' '}
        <span className="font-bold text-slate-800" data-id="element-286">$6.36 USD</span>
        <span className="mx-1.5 text-slate-300" data-id="element-287">·</span>
        Vuelve a $47.00 en{' '}
        <span className="font-mono font-semibold text-slate-700 tabular-nums" data-id="element-288">
          {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
          {formatTime(timeLeft.seconds)}
        </span>
      </p>
    </div>;
}